export default "__VITE_ASSET__ifGeZkkN__"